import {router} from "@inertiajs/vue3";

export const addDisease = (patientId, recordId, disease, preserve) => {
  const payload = {
    abdata_key_miv: disease.Key_MIV,
    disease: disease.Name,
    preserve: preserve === undefined ? null : preserve,
  };

  if (disease.icdcs?.[0]?.Key_ICDC) {
    payload.abdata_key_icdc = disease.icdcs[0].Key_ICDC;
  }

  if (disease.icdcs?.[0]?.Name) {
    payload.name_icdc = disease.icdcs[0].Name;
  }

  router.post(
    route("diseases.store", {
      patient: patientId,
      record: recordId,
    }),
    payload,
    {preserveScroll: true, only: ["flash", "errors", "diseases"]},
  );
};
